import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en/translation.json';
import daTranslations from './locales/da/translation.json';

const resources = {
  en: {
    translation: enTranslations
  },
  da: {
    translation: daTranslations
  }
};

// Initialize with browser language detection
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [], // Don't cache to localStorage to avoid conflicts
    }
  });

// Function to update language based on user settings (called by SettingsContext)
export const updateLanguageFromSettings = (settings: { override_browser_language: boolean; language: string }) => {
  if (settings.override_browser_language) {
    // Use the user's selected language
    i18n.changeLanguage(settings.language);
  } else {
    // Use browser detection
    const browserLang = navigator.language.split('-')[0]; // Get just the language part (e.g., 'en' from 'en-US')
    const supportedLang = resources[browserLang as keyof typeof resources] ? browserLang : 'en';
    i18n.changeLanguage(supportedLang);
  }
};

export default i18n;